<div class="flex flex-col space-y-2 md:p-4">

  <div class="grid grid-cols-3 grid-cols-[10%_30%_60%] md:grid-cols-[10%_50%_40%]
  mr-0.5 md:mr-0 overflow-hidden">
    <a routerLink="/dashboard">
      <div class="pt-4.0 h-8 w-8" id="price-back-arrow">
      </div>
    </a>
    <div><h1 class="pt-2.5">Strom-Preis</h1></div>

    <div class="flex justify-center items-center space-x-2 bg-gray-100 rounded-md mr-2 md:mr-0 w-auto overflow-hidden">
      @if (selectedInterval() === 'day') {
        <app-day-datepicker [date]="selectedDate()" (dateChange)="updateDate($event)"></app-day-datepicker>
      } @else {
        <app-month-datepicker [date]="selectedDate()" (dateChange)="updateDate($event)"></app-month-datepicker>
      }
    </div>
  </div>

  <mat-button-toggle-group [value]="selectedInterval()" (change)="onIntervalSelectionChange($event)"
                           class="flex justify-center md:border-1 border-0 border-t border-b border-l-0 border-r-0
                           rounded-none md:rounded-lg border-gray-200">
    <mat-button-toggle value="day" class="flex-1 border-gray-200">
      Tag
    </mat-button-toggle>
    <mat-button-toggle value="month" class="flex-1 border-gray-200">
      Monat
    </mat-button-toggle>
    <mat-button-toggle value="year" class="flex-1 border-gray-200" disabled="true">
      Jahr
    </mat-button-toggle>
    <mat-button-toggle value="all" class="flex-1 border-gray-200" disabled="true">
      Gesamt
    </mat-button-toggle>
  </mat-button-toggle-group>

  <div class="pb-2">
    <app-price-line-chart
      [interval]="selectedInterval()"
      [date]="selectedDate()"
      [data]="resource.hasValue() ? resource.value() : undefined"
      [loading]="isLoading()">
    </app-price-line-chart>

    @if (noPrices()) {
      <p class="text-center text-sm text-gray-500 pt-2">
        Für diesen Zeitraum sind noch keine Preise verfügbar.
      </p>
    }
    @if (resource.error()) {
      <p class="text-center text-sm text-gray-500 pt-2">
        Die Preise konnten nicht geladen werden.
      </p>
    }
  </div>

  <p class="px-4 pb-5 text-sm text-gray-600">
    Einkaufspreis besteht aus Netzpreis + Arbeitspreis. Verkaufspreis besteht nur aus Arbeitspreis.
  </p>
</div>
